import { useMemo } from 'react';
import { RECERT_CERT_TYPE } from '../../constants/affordableCertificationTypes';
import { COMPLIANCE_APPROVAL_STATUSES_LOWERCASE } from '../../constants/affordableComplianceApprovalStatuses';
import { NEEDS_REVIEW_STATUS } from './hooks.useParseResults';

/**
 * Hook to provide initial filter state for certifications based on certification type
 * @param {string} selectedCertificationType - The currently selected certification type
 * @returns {Object} The initial filter state for the selected certification type
 */
const recertDefaultStatuses = [
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.approved,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.pending,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.pendingFinalApproval,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.approvedPendingSign,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.correctionNeeded,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.correctionNeededFinal,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.notStarted,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.started,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.denied,
  COMPLIANCE_APPROVAL_STATUSES_LOWERCASE.onNoticeHold,
]; // filter out complete by default

const useInitialFilterState = ({
  selectedCertificationType,
  flagCertsForReview,
}) => {
  return useMemo(
    () =>
      ({
        [RECERT_CERT_TYPE]: {
          status: [
            ...recertDefaultStatuses,
            ...(flagCertsForReview ? [NEEDS_REVIEW_STATUS.toLowerCase()] : []),
          ],
        },
      }[selectedCertificationType]),
    [flagCertsForReview, selectedCertificationType],
  );
};

export default useInitialFilterState;
